import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { AlertMessageInterfaceState } from '../../store/state/alert-message.state';
import { ConstsHelper } from '../../../../helpers/consts.helper';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-alert-messages',
  templateUrl: './alert-messages.component.html',
  styleUrls: ['./alert-messages.component.css'],
  standalone: false
})
export class AlertMessagesComponent implements OnInit {

  mappingClass = {
    200: 'alert-success',
    400: 'alert-danger',
    300: 'alert-warning',
  };
  message: string = null;
  class: string = null;
  alertMessageVisibility: boolean;
  timeoutHandle: any;
  brand?: string;

  constructor(private store: Store<any>) {}

  ngOnInit() {
    this.brand = environment.data.brand;
    this.alertMessageVisibility = false;
    this.store.pipe(select(ConstsHelper.REDUCER_ALERT_MESSAGES)).subscribe((response: AlertMessageInterfaceState) => {
      if (response.alert != null) {
        window.clearTimeout(this.timeoutHandle);
        this.message = response.alert.message;
        this.class = this.mappingClass[response.alert.code];
        this.alertMessageVisibility = !(response.alert.visibility === false);
        document.getElementById('wrapper-content').scrollTop = 0;
        this.timeoutHandle = setTimeout(function() { this.close(); }.bind(this), 10000);
      }
    });
  }

  close() {
    this.alertMessageVisibility = false;
    this.message = null;
    this.class = null;
  }
}
